/**
 * External dependencies
 */
import useSWR from "swr";

/**
 * Internal dependencies
 */
import { fetcher } from "./fetcher";

/**
 * Configuration
 */
import config from "../config";
const { ajax_url, actions } = config;

export function useFilters() {
	const lang =  document.documentElement.getAttribute('lang');
	const { data, error } = useSWR([ajax_url, actions.filters + `&lang=${lang}`], fetcher);
	return {
		filters: data,
		error,
	};
}
